import { Outlet, Navigate } from "react-router-dom";

import { useAuthentication } from "../../services/authentication/authentication.context";

export const Protected = () => {
    const { isAuthenticated } = useAuthentication();

    return (
        isAuthenticated === false ?
        <Navigate to="/" /> : <Outlet />
    )
};